// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { ApiHandlerDiscreteParameter, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { GetWishListsApiParameter } from "@insite/client-framework/Services/WishListService";
import loadWishList from "@insite/client-framework/Store/Data/WishLists/Handlers/LoadWishList";
import { getWishListState } from "@insite/client-framework/Store/Data/WishLists/WishListsSelectors";
import { DispatchLoadWishListIfNeeded } from "@insite/client-framework/Store/Pages/MyListDetails/Handlers/LoadWishListIfNeeded";
import { chain } from "@insite/client-framework/Store/Pages/MyListDetails/Handlers/LoadWishListIfNeeded";
import { OrderModel } from "@insite/client-framework/Types/ApiModels";

type HandlerType = ApiHandlerDiscreteParameter<
    { wishListId: string; isWebRequest?: boolean },
    GetWishListsApiParameter,
    OrderModel
>;

export const XngDispatchLoadWishListIfNeeded: HandlerType = props => {
    const wishListState = getWishListState(props.getState(), props.parameter.wishListId);
    if (
        !wishListState.value ||
        wishListState.value.schedule === undefined ||
        !wishListState.value.sendDayOfMonthPossibleValues ||
        !wishListState.value.sendDayOfWeekPossibleValues ||
        wishListState.value.sendDayOfMonthPossibleValues.length < 1 ||
        wishListState.value.sendDayOfWeekPossibleValues.length < 1 ||
        wishListState.value.wishListTags === null
    ) {
        // XNG-Changes
        props.dispatch(
            loadWishList({
                wishListId: props.parameter.wishListId,
                exclude: ["listLines"],
                expand: ["schedule", "sharedUsers", "favorite", "hidden", "tags"],
                isWebRequest: props.parameter.isWebRequest,
            } as any),
        );
    }
};

replaceInChain(chain, DispatchLoadWishListIfNeeded, XngDispatchLoadWishListIfNeeded);
